import React from 'react';
import { useParams } from 'react-router';
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { createURL } from '@sm/utils';
import { Responsive } from '@wds/responsive';

import { PricingData, NavRouteParams, PackageProps } from '~pricing/lib/summaryPackages';

import BackToSummary from '~pricing/components/BackToSummary';
import ROUTE_CONFIG from '~pricing/components/Navigation/routes';
import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import DetailsPackageHeader from '~pricing/components/DetailsTable/PackageHeader';
import Categories from '~app/pages/Pricing/components/DetailsTable/Categories';
import COPY from '~app/pages/Pricing/copy';
import usePackagesWithCTALabel from '~pricing/hooks/usePackagesWithCTALabel';

import useDetailsStyles from './useStyles';

export default function PricingDetailsPage({ packageData, packageSet }: PricingData): JSX.Element {
  const { packages } = usePackagesWithCTALabel(packageData, packageSet);
  const { Details, Sticky } = useDetailsStyles({
    packageCount: packages.length,
  });
  const { canonicalPath } = useParams<NavRouteParams>();

  if (!packageData) {
    return <></>;
  }

  return (
    <>
      <header>
        <BackToSummary url={createURL(`/pricing/${canonicalPath}`, ROUTE_CONFIG[canonicalPath].queryString)} />
        <MainHeading>{t(COPY.DETAILS_HEADING)}</MainHeading>
        <Navigation />
      </header>
      <Box className={Details}>
        <Responsive maxWidth="md">
          <Box>
            {packages.map((pricingPackage: PackageProps, index: number) => {
              const { skuCost, details, package: packageName, ctaLabel } = pricingPackage;
              const currentPackage = packages.find(pkg => pkg.package === packageName);
              return (
                <div key={`Mobile-${packageName}`}>
                  <DetailsPackageHeader
                    ctaLabel={ctaLabel}
                    skuCosts={skuCost}
                    details={details}
                    packageName={packageName}
                    packageType={canonicalPath}
                    index={`${index + 1}`}
                    data-testid="Details__PackageHeader"
                  />
                  {currentPackage && <Categories displayedPackages={[currentPackage]} isMobile />}
                </div>
              );
            })}
          </Box>
        </Responsive>
        <Responsive minWidth="md">
          <>
            <Box className={Sticky} data-testid="Details__Sticky">
              {packages.map((pricingPackage: PackageProps, index: number) => {
                const { skuCost, details, package: packageName, ctaLabel } = pricingPackage;

                return (
                  <DetailsPackageHeader
                    key={`DetailsHeader-Desktop${packageName}`}
                    ctaLabel={ctaLabel}
                    skuCosts={skuCost}
                    details={details}
                    packageName={packageName}
                    packageType={canonicalPath}
                    index={`${index + 1}`}
                  />
                );
              })}
            </Box>
            <Categories displayedPackages={packages} />
          </>
        </Responsive>
      </Box>
    </>
  );
}
